import { render, staticRenderFns } from "./ArchivedTrucksLogs.vue?vue&type=template&id=7d3e7374&scoped=true&"
import script from "./ArchivedTrucksLogs.vue?vue&type=script&lang=js&"
export * from "./ArchivedTrucksLogs.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedTrucksLogs.vue?vue&type=style&index=0&id=7d3e7374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3e7374",
  null
  
)

export default component.exports